import {createAsyncAction} from 'typesafe-actions';
import {AxiosError} from 'axios';
import {ISetEditorJob} from 'lib/api/setEditorJob';

export const SAVE_POST = 'setEditorJob/SAVE_POST';
export const SAVE_POST_SUCCESS = 'setEditorJob/SAVE_POST_SUCCESS';
export const SAVE_POST_ERROR = 'setEditorJob/SAVE_POST_ERROR';

export const setEditJobAction = createAsyncAction(
  SAVE_POST,
  SAVE_POST_SUCCESS,
  SAVE_POST_ERROR,
)<ISetEditorJob, ISetEditorJob, AxiosError>();
